import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap"
import Notifications from "components/Notifications"
import DeleteConfirmationModel from "components/delete-confirmation-model"
import { getCode } from 'helpers/basic_helper'
import { MASTER_OPTIONS_URL } from "helpers/url_helper"
import { useDispatch, useSelector } from 'react-redux'
import { masterOptions } from 'store/actions'
import { GetHelper, SubmitHelper } from '../CallHelper'
import FormComponent from "../FormComponent"
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";

const isType = 'shade'
const Shade = () => {
    const dispatch = useDispatch()
    const { DDMasters } = useSelector(state => state.Master);
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState(null)
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })

    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async (ID = false) => {
        if (!ID) { setIsLoading(true); }
        const res = await GetHelper(`${process.env.REACT_APP_SHADE}&page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, ID)
        if (ID) {
            setEditableObj(...res)
            isOpen(true)
        } else {
            setIsLoading(false)
            setDataRows(res)
        }
    }
    useEffect(() => {
        dispatch(masterOptions({ url: MASTER_OPTIONS_URL }))
    }, [])

    /**
     * Submit or Update data Api Call
     * @param {Form Data} data 
     * @method {post} POST 
     */
    const submitForm = async (data) => {
        const checkCode = !dataRows ? [] : dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.target.code.value).toUpperCase())
        if (data?.target?.id?.value == '' && checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        const res = await SubmitHelper(`${process.env.REACT_APP_SHADE}`, {
            "title": data.target.title.value,
            "code": data.target.code.value,
            "shadeguide": data.target.shadeguide.value
        }, data?.target?.id?.value || null);

        if (res) {
            getData()
            isOpen(false)
            Notifications('You have successfully added a Shade.!')
        }
    }

    /**
     * Get Single row using url params ?q=?
     * @param {Row_id} q 
     * @method {get} GET 
     */
    const handleEdit = q => {
        if (q > 0) {
            getData(q)
        }
    }

    /**
     * Chnage Row Status By ID and condition Based Status passing,
     * @param {row_id} q 
     * @param {row Status} status 
     * @method {del} DELETE 
     */
    const handleRemove = async (q, status, code) => {
        if (q > 0) {
            setIsDeleteModel({ url: process.env.REACT_APP_SHADE, q, status, code })
        }
    }
    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = [
        {
            dataField: 'id',
            text: '#'
        }, {
            dataField: 'title',
            text: 'Shade'
        }, {
            dataField: 'code',
            text: 'Code'
        }, {
            dataField: 'shadeguide_title',
            text: 'Shade Guide'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Track or status" ><i className={`fas fa-pencil-alt`} /></Link>
                <Link to="#" className="ms-1 btn btn-outline-danger btn-sm edit" onClick={() => handleRemove(row.id, row.status, row.code)} title="Track or status" ><i className={`fas fa-trash-alt`} /></Link>
            </>
        }
    ];

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj ? editableObj.id : '',
            col: 12
        }, {
            name: "title",
            label: "Shade",
            placeholder: "Please Enter Shade",
            required: true,
            type: 'text',
            value: editableObj ? editableObj.title : '',
            col: 12
        }, {
            name: "code",
            label: "Code",
            placeholder: "Code",
            required: true,
            type: 'text',
            value: editableObj ? editableObj.code : getCode("shade", dataRows?.total_rows),
            col: 12
        }, {
            name: "shadeguide",
            label: 'Shade Guide',
            placeholder: "Please Select Shade Guide",
            required: true,
            type: 'select',
            options: DDMasters?.shadeguide?.map(v => ({ 'label': v.title, 'value': v.code })),
            value: editableObj ? DDMasters?.shadeguide?.filter(v => v.code == editableObj?.shadeguide).map(v => ({ label: v.title, value: v.code }))[0] : '',
            col: 12
        }
    ]

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | {isType}</title></MetaTags>
                <Container fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables
                                        isSearch={true}
                                        columns={datatableData}
                                        showTableOnly={true}
                                        rowsLength={dataRows?.total_rows || 0}
                                        rows={dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={() => {
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}
                                        title="All Shades"
                                        loading={isLoading}
                                        isAdd={true}
                                        isTableHead={true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Datatable */}
            {
                open &&
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} Shade`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={isLoading}
                    editableObj={editableObj}
                    onDrawerClose={() => {
                        setEditableObj(null)
                        isOpen(!open)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}

            {isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} />}
        </React.Fragment>
    )
}

export default Shade
